// Delete file when cleaning up jira_list_nin_merge

import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	allWorkTabRemovedTitle: {
		id: 'horizontal-nav-tabs.all-work-tab-removed-title.non-final',
		defaultMessage: 'Your current view is out of sync',
		description: 'Title letting the user know that their current view is outdated',
	},
	allWorkTabRemovedDescription: {
		id: 'horizontal-nav-tabs.all-work-tab-removed-description.non-final',
		defaultMessage: 'Refresh the page to load the latest changes',
		description:
			'Description telling the user to refresh the page, in order to see the latest changes',
	},
	allWorkTabRemovedButton: {
		id: 'horizontal-nav-tabs.all-work-tab-removed-button.non-final',
		defaultMessage: 'Refresh',
		description: 'Label for the button that refreshes the page on click',
	},
});
